var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order-details"}},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Method")]),_vm._v(" "),_c('div',{staticClass:"service-type-section"},[_c('ServiceTypeChooser',{attrs:{"showAddressChooser":true}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('BaseDatePicker'),_vm._v(" "),_c('v-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491b7aea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderDetails.vue
// module id = null
// module chunks = 